import React, { useState, useContext } from 'react';

import WomenImg from '../img/about/kamesh12.png';

import emailjs from 'emailjs-com';

import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

import { CursorContext } from '../context/CursorContext';

const Contact = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  const [data, setData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const { name, email, message } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const submitHandle = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_q3zojoc',
        'template_gvajryy',
        e.target,
        'NWjvSHFrd2TdVJGw5'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    setData({
      name: '',
      email: '',
      message: '',
    });
  };
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: window.innerHeight }}
      transition={transition1}
      className="section hero"
    >
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col lg:flex-row h-full items-center justify-center  gap-x-18 text-center lg:text-left lg:pt-16">
          <div className="flex-1  lg:max-h-max order-1 lg:order-none overflow-hidden">
            <motion.img
              whileHover={{ scale: 1.1 }}
              transition={transition1}
              src={WomenImg}
              alt=""
            />
          </div>
          <div
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            className="flex-1 pt-32 pb-0 lg:pt-0  lg:w-auto z-8 flex flex-col justify-center items-center px-10 text-justify  lg:items-start text-primary "
          >
            <h1 className="h2 text-8xl">Contact Me</h1>
            <br />
            <form onSubmit={submitHandle} className="">
              <span>
                <b className="text-lg">
                  <label>Name : </label>
                </b>
                <input
                  required
                  type="text"
                  name="name"
                  value={name}
                  id="name"
                  placeholder="Enter Your Name"
                  onChange={handleChange}
                  className="p-3 mx-8 w-80 rounded-2xl "
                />
              </span>
              <br />
              <br />
              <span>
                <b className="text-lg">
                  <label htmlFor="email">Email : </label>
                </b>
              </span>
              <input
                required
                type="email"
                name="email"
                id="email"
                value={email}
                onChange={handleChange}
                placeholder="Enter Your Email"
                className="p-3 mx-9 w-80 rounded-2xl"
              />
              <br />
              <br />
              <b className="text-lg relative bottom-10 ">
                <label>Message :</label>
              </b>
              <textarea
                name="message"
                id="message"
                cols="35"
                rows="3"
                required
                value={message}
                onChange={handleChange}
                placeholder="Enter Your Message"
                className="p-2 mx-4 rounded-2xl resize-none"
              ></textarea>
              <br />
              <br />
              <button className="btn px-14 py-4 shadow-sm">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
